/**
noop()
Returns undefined.
*/

export default function noop() {}
